import * as React from 'react';

const EditPencil = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12}
    fill="none"
    {...props}
  >
    <path
      d="m2.741 8.333 5.917-5.916-.825-.825L1.917 7.51v.824h.824ZM3.225 9.5H.75V7.025L7.42.355a.583.583 0 0 1 .825 0l1.65 1.65a.583.583 0 0 1 0 .825L3.226 9.5ZM.75 10.667h10.5v1.166H.75v-1.166Z"
      fill="#fff"
    />
  </svg>
);

export default EditPencil;
